
import React, { useState } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';
import './GoalsEditor.css';

const defaultGoals = [
  {
    id: 1,
    level: 1,
    name: "First Steps",
    target: 5,
    reward: "Welcome bonus - 10% discount"
  },
  {
    id: 2,
    level: 2,
    name: "Essential Explorer",
    target: 15,
    reward: "Free sample kit"
  },
  {
    id: 3,
    level: 3,
    name: "Wellness Warrior",
    target: 30,
    reward: "Exclusive diffuser"
  },
  {
    id: 4,
    level: 4,
    name: "Oil Enthusiast",
    target: 50,
    reward: "Premium oil collection"
  },
  {
    id: 5,
    level: 5,
    name: "Master Blender",
    target: 100,
    reward: "VIP consultation session"
  }
];

// const GoalsEditor = ({ goals, onSave, onClose }) => {
  const GoalsEditor = ({ goals = defaultGoals, onSave, onClose }) => {
  const [editedGoals, setEditedGoals] = useState([...goals]);

  const addGoal = () => {
    const newGoal = {
      id: Date.now(),
      level: editedGoals.length + 1,
      name: `Level ${editedGoals.length + 1}`,
      target: 10,
      reward: 'Achievement unlocked!'
    };
    setEditedGoals([...editedGoals, newGoal]);
  };

  const updateGoal = (id, field, value) => {
    setEditedGoals(prev => prev.map(goal =>
      goal.id === id ? { ...goal, [field]: value } : goal
    ));
  };

  const deleteGoal = (id) => {
    setEditedGoals(prev => prev.filter(goal => goal.id !== id));
  };

  const handleSave = () => {
    const sortedGoals = editedGoals.map((goal, index) => ({
      ...goal,
      level: index + 1
    }));
    onSave(sortedGoals);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content goals-editor">
        <div className="modal-header">
          <h3>Edit Goals</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="goals-list">
          {editedGoals.sort((a, b) => a.level - b.level).map((goal, index) => (
            <div key={goal.id} className="goal-item">
              <div className="goal-header">
                <h4>Level {index + 1}</h4>
                <button
                  className="delete-goal-btn"
                  onClick={() => deleteGoal(goal.id)}
                >
                  <Trash2 size={16} />
                </button>
              </div>

              <div className="goal-fields">
                <div className="field-group">
                  <label>Goal Name</label>
                  <input
                    type="text"
                    value={goal.name}
                    onChange={(e) => updateGoal(goal.id, 'name', e.target.value)}
                  />
                </div>

                <div className="field-group">
                  <label>Target (people)</label>
                  <input
                    type="number"
                    value={goal.target}
                    onChange={(e) => updateGoal(goal.id, 'target', parseInt(e.target.value))}
                    min="1"
                  />
                </div>

                <div className="field-group">
                  <label>Reward Message</label>
                  <input
                    type="text"
                    value={goal.reward}
                    onChange={(e) => updateGoal(goal.id, 'reward', e.target.value)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="add-goal-btn" onClick={addGoal}>
          <Plus size={20} />
          Add New Goal
        </button>

        <div className="form-actions">
          <button className="save-btn" onClick={handleSave}>Save Goals</button>
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default GoalsEditor;
